export default "__VITE_ASSET__DSIdFb$P__"